import { jsx } from "react/jsx-runtime";
import { ChevronDown } from "@wix/wix-ui-icons-common/on-stage";
import { TextFieldTheme } from "@wix/wix-ui-tpa/cssVars";
import classNames from "classnames";
import { useMemo, useCallback } from "react";
import { useConfig } from "../../contexts/config-context.js";
import { useId } from "../../hooks/use-id.js";
import { st, classes } from "./autocomplete-wut.cssVars.st.css";
import { OptionFactory } from "./wut/WixUiCoreComponents/components/CoreDropdownOption/OptionFactory.js";
import { CoreInputWithOptions } from "./wut/WixUiCoreComponents/components/CoreInputWithOptons/CoreInputWithOptions.js";
const ARROW_DOWN = /* @__PURE__ */ jsx("span", { className: classes.suffix, children: /* @__PURE__ */ jsx(ChevronDown, { width: 24, height: 24, className: classes.arrowIcon }) });
const Prefix = ({ children }) => {
  return /* @__PURE__ */ jsx("div", { className: classes.prefix, children });
};
const createOption = (option) => OptionFactory.create(option);
const AutocompleteWUT = ({
  id,
  className,
  value,
  options,
  disabled,
  placeholder,
  error,
  showArrow,
  initialSelectedId,
  prefix,
  onInitialSelectedOptionsSet,
  filterPredicate,
  onSelect,
  onManualInput,
  onChange,
  onBlur,
  onFocus,
  ariaDescribedBy,
  theme = TextFieldTheme.Box
}) => {
  const { isRTL: rtl } = useConfig();
  const inputProps = useMemo(() => {
    return {
      id,
      value: value ?? "",
      error,
      placeholder,
      disabled,
      suffix: showArrow ? ARROW_DOWN : void 0,
      prefix: prefix ? /* @__PURE__ */ jsx(Prefix, { children: prefix }) : void 0,
      onChange,
      onBlur,
      onFocus,
      "aria-autocomplete": "both",
      "aria-describedby": ariaDescribedBy
    };
  }, [
    id,
    value,
    error,
    placeholder,
    disabled,
    showArrow,
    prefix,
    onChange,
    onBlur,
    onFocus,
    ariaDescribedBy
  ]);
  const dropdownId = useId();
  const handleContentMouseDown = useCallback((e) => {
    e.preventDefault();
  }, []);
  const handleInitialSelectedOptionsSet = useCallback(
    (selectedOptions) => {
      onInitialSelectedOptionsSet?.(selectedOptions[0]);
    },
    [onInitialSelectedOptionsSet]
  );
  return /* @__PURE__ */ jsx(
    CoreInputWithOptions,
    {
      id: dropdownId,
      className: st(
        classes.root,
        {
          disabled,
          error,
          hasPrefix: Boolean(prefix),
          hasSuffix: showArrow,
          rtl,
          theme
        },
        classes.override,
        classNames(className, classes.theme, {
          [classes.rtl]: rtl
        })
      ),
      inputProps,
      options,
      initialSelectedIds: initialSelectedId ? [initialSelectedId] : void 0,
      onInitialSelectedOptionsSet: handleInitialSelectedOptionsSet,
      filterPredicate,
      highlightMatches: false,
      allowReselect: true,
      onSelect,
      onManualInput,
      onContentMouseDown: handleContentMouseDown
    }
  );
};
export {
  AutocompleteWUT,
  createOption
};
//# sourceMappingURL=autocomplete-wut.js.map
